(() => {
  const quantitySelector =
    "input.m-quantity__input[name='quantity'], input[name='quantity'][type='number']";

  const isInvalidQuantity = (input) => {
    const value = input.value.trim();
    const quantity = Number(value);
    const minimum = Number(input.min || input.dataset.min || 1);

    return (
      value === "" ||
      !Number.isFinite(quantity) ||
      !Number.isInteger(quantity) ||
      quantity < minimum
    );
  };

  const findAddButton = (input) => {
    const card = input.closest(
      ".m-product-card, .m-product-form, product-form, form"
    );

    const formId = input.getAttribute("form");
    const linkedForm = formId ? document.getElementById(formId) : null;

    return (
      card?.querySelector(
        "button[name='add'], .m-add-to-cart, .hskd-add"
      ) ||
      linkedForm?.querySelector(
        "button[name='add'], .m-add-to-cart, .hskd-add"
      )
    );
  };

  const validateQuantity = (input, showMessage = false) => {
    const invalid = isInvalidQuantity(input);
    const addButton = findAddButton(input);

    input.setCustomValidity(
      invalid ? "Please enter a whole number." : ""
    );

    if (addButton) {
      addButton.disabled = invalid;
      addButton.setAttribute("aria-disabled", String(invalid));
    }

    if (invalid && showMessage) {
      input.reportValidity();
    }

    return !invalid;
  };

  document.addEventListener("input", (event) => {
    if (!event.target.matches(quantitySelector)) return;
    validateQuantity(event.target);
  });

  document.addEventListener("change", (event) => {
    if (!event.target.matches(quantitySelector)) return;
    validateQuantity(event.target, true);
  });

  document.addEventListener(
    "click",
    (event) => {
      const addButton = event.target.closest(
        "button[name='add'], .m-add-to-cart, .hskd-add"
      );

      if (!addButton) return;

      const area = addButton.closest(
        ".m-product-card, .m-product-form, product-form, form"
      );

      const input =
        area?.querySelector(quantitySelector) ||
        document.querySelector(
          `${quantitySelector}[form="${addButton.getAttribute("form")}"]`
        );

      if (input && !validateQuantity(input, true)) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        input.focus();
      }
    },
    true
  );

  document.addEventListener(
    "submit",
    (event) => {
      const input = event.target.querySelector(quantitySelector);
      if (!input) return;

      if (!validateQuantity(input, true)) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    },
    true
  );
})();